export default {
  createZoomMeeting: '/zoom/createZoomMeeting',
  getrecordingLink: '/zoom/getrecordingLink',
  getMeetingAttendence: '/zoom/getMeetingAttendence'
}
